import axios from '@/libs/api.request'

export const getSecurityConfigList = (page, limit, key) => {
  return axios.request({
    url: '/v1/system/security-config/',
    method: 'get',
    params: {
      page,
      limit,
      key: key
    }
  })
}

export const operationSecurityConfig = (data, meth) => {
  return axios.request({
    url: '/v1/system/security-config/',
    method: meth,
    data
  })
}